log = require 'loglevel'
Tween = require 'tween'
imageManager = require 'imageManager'
eventManager = require 'eventManager'
soundManager = require 'soundManager'
gameModel = require 'gameModel'
imageModel = require 'imageModel'

class ScratchArea extends PIXI.Sprite

  name: 'ScratchArea'
  done: false
  lastPos: null
  mouseIsDown: false
  allowScratching: false
  isUnscratched: true
  isCalculating: false
  scaleFactor: 4
  scratchThrottling: 150
  dpi: __dpi
  debug: false

  #-------------------------

  render: (@img, width, height, @offsetX, @offsetY) ->
    # log.info @name, 'render', img, width, height, @offsetX, @offsetY

    @completedColors = []
    @lastPos = null

    @canvas = document.createElement('canvas')
    @ctx = @canvas.getContext('2d')
    @canvas.width = width*@dpi
    @canvas.height = height*@dpi
    @canvas.id = 'scratch-canvas'

    @ctx.drawImage @img,0,0,@canvas.width,@canvas.height
    @ctx.globalCompositeOperation = "destination-out"

    @texture =  new PIXI.Texture.fromCanvas(@canvas)

    @height = height
    @width = width
    @position.x = 0
    @position.y = 0
    @interactive = true
    @buttonMode = true


    # Mask
    maskH = height/@scaleFactor
    maskW = width/@scaleFactor

    @maskCanvas = document.createElement("canvas")
    @maskCtx = @maskCanvas.getContext("2d")
    @maskCanvas.width = maskW
    @maskCanvas.height = maskH
    @maskCanvas.id = 'mask-canvas'

    if @maskCtx.imageSmoothingEnabled?
      @maskCtx.imageSmoothingEnabled = false
    else
      @maskCtx.webkitImageSmoothingEnabled = false
      @maskCtx.mozImageSmoothingEnabled = false
      @maskCtx.oImageSmoothingEnabled = false

    if @debug

      existingScratch = document.getElementById('scratch-canvas')
      existingScratch.remove() if existingScratch?
      document.body.appendChild(@canvas)

      existingMask = document.getElementById('mask-canvas')
      existingMask.remove() if existingMask?
      document.body.appendChild(@maskCanvas)


    @originalCanvas = document.createElement("canvas")
    @originalCtx = @originalCanvas.getContext("2d")
    @originalCanvas.width = width
    @originalCanvas.height = height
    @originalCtx.drawImage @img,0,0,@img.width,@img.height,0,0,width,height

    texture = PIXI.Texture.fromImage(imageModel.brushImage)
    @brushImg = texture.baseTexture.source

    @allowScratching = false

    @

  #-------------------------

  reset: ->

    @done = false
    @interactive = true
    @mouseIsDown = false
    @allowScratching = false
    @isUnscratched = true
    @isCalculating = false
    @completedColors = []
    @lastPos = null
    @ctx.globalCompositeOperation = "source-over"
    @ctx.drawImage @img,0,0,@canvas.width,@canvas.height
    @texture =  new PIXI.Texture.fromCanvas(@canvas)
    @texture.update()
    @ctx.globalCompositeOperation = "destination-out"



  #-------------------------

  setupMasks: (prizes, multip=null) ->

    @maskCtx.rect(0,0,@maskCanvas.width,@maskCanvas.height)
    @maskCtx.fillStyle = "white"
    @maskCtx.fill()

    for prize in prizes
      @addMask prize, false

    @addMask multip, true if multip?

    # Setup
    @originalColorCounts = @getColoredPixelCount @maskCtx
    @prizeCount = UTIL.keys(@originalColorCounts).length

    @isUnscratched = true

  #-------------------------

  addMask: (prize, isMultip=false) ->

    spriteRes = prize.getByTag('prize').texture.baseTexture.resolution

    x = prize.x
    y = prize.y
    w = prize.width
    h = prize.height

    channels = prize.colorCode.split("-");
    c = "rgb(#{channels[0]},#{channels[1]},#{channels[2]})"

    w = w/@scaleFactor
    h = h/@scaleFactor

    w = Math.floor w/2/spriteRes
    h = Math.floor h/2/spriteRes

    x = Math.floor (x/@scaleFactor)-(w/2)
    y = Math.floor (y/@scaleFactor)-(h/2)

    @maskCtx.fillStyle = c
    @maskCtx.fillRect x, y, w, h

  #-------------------------

  calculateCoordinates: (e,callback) ->

    if @done or not @allowScratching
      callback(false)
      return

    pos = e.data.global

    x = pos.x - @offsetX - gameModel.stageX
    y = pos.y - @offsetY - gameModel.stageY

    w = @canvas.width
    h = @canvas.height

    # log.info x,y,w,h

    if x < 0 or y < 0 or x > w or y > h
      callback(false)
      return

    pixelData = @originalCtx.getImageData(x, y, 1, 1).data

    # not in mask
    if pixelData[3] is 0
      callback(false)
      return

    # prevent scrolling
    e.data.originalEvent.preventDefault()

    radius = 80*@dpi
    offset = radius/2

    maskX = x/@scaleFactor
    maskY = y/@scaleFactor
    x = x * @dpi
    y = y * @dpi

    # pre scratching - will something change
    oldData = @ctx.getImageData(x-offset,y-offset,radius,radius).data
    # oldData = data.slice(0)

    callback(true)

    # scratch it
    @scratch x, y, maskX, maskY, =>

      # post scratching - did something change
      newData = @ctx.getImageData(x-offset,y-offset,radius,radius).data

      if not @arraysIdentical oldData, newData

        direction = 0
        direction = e.data.global.x - @lastPos if @lastPos?

        eve =
          x: e.data.global.x - gameModel.stageX
          y: e.data.global.y - gameModel.stageY
          dir: direction

        @lastPos = e.data.global.x

        # fire event for scratching
        eventManager.trigger 'scratching', eve


  #-----------------------------------------

  arraysIdentical: (a, b) ->
    i = a.length
    if i != b.length
      return false
    while i--
      if a[i] != b[i]
        return false
    true

  #-----------------------------------------

  scratch: (x, y, maskX, maskY, cb) ->

    if @isUnscratched
      @game.beganScratching()
      @isUnscratched = false

    brushSize = gameModel.brushSize * @dpi
    maskBrushSize = gameModel.brushSize / @scaleFactor

    @ctx.beginPath()
    @maskCtx.fillStyle = "#FFFFFF"
    @maskCtx.beginPath()

    @drawBrush(@ctx, @maskCtx, x, y, maskX, maskY, @brushImg, brushSize, maskBrushSize)

    @ctx.fill()
    @maskCtx.fill()

    #---

    # we are processsing this time
    return if @isProcessingPercent
    @isProcessingPercent = true

    return if @isCalculating

    setTimeout (=>
      @calculateCompletion()
      @isProcessingPercent = false
      cb()
    ), 150 #@scratchThrottling


  #-----------------------------------------

  calculateCompletion: () ->

    @isCalculating = true

    @updatedColorCounts = @getColoredPixelCount @maskCtx

    if @calculateIsEnded @updatedColorCounts

      @game.willClearAfterUserScratchedManually()

      @clear true, =>
        @game.allScratched()

    @isCalculating = false

  #-----------------------------------------

  getColoredPixelCount: (ctx) ->

    data = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height).data
    r = 0
    g = 1
    b = 2

    colors = {}

    while r < data.length

      red = data[r]
      green = data[r+g]
      blue = data[r+b]

      key = "#{red}-#{green}-#{blue}"

      if key isnt '255-255-255'
        if colors[key]?
          colors[key]++
        else
          colors[key]=1

      r += 4

    for k,v of @originalColorCounts
      colors[k] = 0 unless colors[k]?

    colors

  #-----------------------------------------

  calculateIsEnded: (updatedCounts) ->

    donePercent = gameModel.donePercent
    count = 0
    completedColor = ''

    for key, value of updatedCounts
      continue unless @originalColorCounts[key]?

      isInCompleted = UTIL.contains(@completedColors, key)
      continue if isInCompleted

      if value is 0 and not isInCompleted
        completedColor = key
        @completedColors.push key
        continue

      originalValue = @originalColorCounts[key]
      percent = ((originalValue-value)/originalValue)*100

      if percent < donePercent
        count++
      else
        completedColor = key
        @completedColors.push key

    if count < @prizeCount and completedColor isnt ''
      @prizeCount = count
      @game.prizeScratched(completedColor)

    return count is 0

  #-----------------------------------------

  clear: (animate, callback) ->

    if @isUnscratched
      @game.beganScratching()
      @isUnscratched = false

    @done = true
    @interactive = false

    w = @width * @dpi
    h = @height * @dpi

    if animate
      unitSize = 20 * @dpi
      brushSize = gameModel.brushSize * @dpi
      scratchAngle = (Math.random() * 30) - 15
      y = brushSize/2
      if scratchAngle > 0
        x = 0
        direction = true
      else
        x = w
        direction = false

      soundManager.reveal()
      @timeBasedClearAll x,y,w,h,direction,scratchAngle,@brushImg,brushSize, =>
      # @animateClearAll x,15,w,h,unitSize,brushSize,@brushImg,10,direction,scratchAngle,=>
        @revealAll(w,h,callback)
        soundManager.stopReveal()

    else
      @revealAll(w,h,callback)

  #-----------------------------------------

  revealAll: (w,h,cb) ->

    @ctx.beginPath()
    @ctx.fillStyle = "#FFFFFF"
    @ctx.fillRect 0, 0, w, h

    cb(true) if cb?

  #-----------------------------------------

  timeBasedClearAll: (x,y,w,h,dir,angle,brushImg,brushSize,cb) ->

    location =
      x: x
      y: y

    target = w
    target = 0 if not dir

    to =
      x:target
      repeat:5
      yoyo:true
      onRepeat: ->
        location.y = location.y+(brushSize*0.5)

        # change directions
        dir = !dir
        # console.log dir, angle

      onUpdate: (d) =>
        if dir
          location.y = location.y - angle
        else
          location.y = location.y + angle

        # console.log location.y
        @drawBrush @ctx, null, location.x, location.y, null, null, brushImg, brushSize, null
      onComplete: =>
        cb()
      ease:Linear.easeNone

    tween = Tween.to(location, 0.25, to)

  #-----------------------------------------

  animateClearAll: (x,y,w,h,units,brushSize,brushImg,delay,dir,angle,callback) ->

    # done
    if y > h
      callback() if callback?
      return

    @drawBrush @ctx, null, x, y, null, null, brushImg, brushSize, null

    # go right
    if dir
      x = x + units
      y = y + angle

    # go left
    else
      x = x - units
      y = y - angle


    # end of the row
    if x >= w-2 or x < 2

      # change directions
      dir = !dir

      # how far down to go
      y = y + (brushSize/2)


    # fake next touch
    setTimeout (=>
      @animateClearAll(x,y,w,h,units,brushSize,brushImg,delay,dir,angle,callback)
    ), delay


  #-------------------------

  getCanvas: ->
    @texture.baseTexture.source

  #-------------------------

  getContext: ->
    @getCanvas().getContext('2d')

  #-------------------------

  mousedown: ->
    @mouseIsDown = true

  #-------------------------

  mouseup: ->
    @mouseIsDown = false

  #-------------------------

  mouseupoutside: ->
    @mouseIsDown = false

  #-------------------------

  mousemove: (data) ->
    return unless @mouseIsDown

    @calculateCoordinates data, (didScratch) =>
      @scratchSound(didScratch)

  #-------------------------

  touchmove: (e) ->

    e.data.originalEvent.preventDefault()

    @calculateCoordinates e, (didScratch) =>
      @scratchSound(didScratch)

  #-------------------------

  touchstart: (data) ->
    log.info 'touchstart'

  #-------------------------

  touchend: (data) ->
    log.info 'touchend'

  #-------------------------

  drawBrush: (ctx, maskCtx, x, y, maskX, maskY, img, brushSize, maskBrushSize) ->

    angle = Math.random() * 360

    img.width = brushSize
    img.height = brushSize
    w = img.width
    h = img.height

    @drawRotatedImage ctx, img, x, y, w, h, angle

    if maskCtx?
      img.width = maskBrushSize if maskBrushSize
      img.height = maskBrushSize if maskBrushSize
      w = img.width
      h = img.height
      @drawRotatedImage maskCtx, img, maskX, maskY, w, h, angle

  #-----------------------------------------

  drawRotatedImage: (context, image, x, y, width, height, angle) ->

    # save the current co-ordinate system
    # before we screw with it
    context.save()

    # move to the middle of where we want to draw our image
    context.translate(x, y)

    # rotate around that point, converting our
    # angle from degrees to radians
    context.rotate(angle * (Math.PI/180))

    # draw it up and to the left by half the width
    # and height of the image
    context.drawImage(image, -width / 2, -height / 2, width, height)

    # and restore the co-ords to how they were when we began
    context.restore()

  # -------------------------------------------

  scratchSound: (didScratch) ->
    # return



    if didScratch
      soundManager.revealShort()
    #   clearTimeout @scratchTimeout
    #   @scratchTimeout = setTimeout(->
    #     soundManager.stopReveal()
    #   ,500)
    # else
    #   soundManager.stopReveal()

  # -------------------------------------------

module.exports = ScratchArea


// WEBPACK FOOTER //
// ./coffee/view/scratch-area.coffee